var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  x: 0.5,
  y: 0.5,
  stroke: "currentColor",
  strokeDasharray: "2 2",
  strokeOpacity: 0.88,
  rx: 19.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeOpacity: 0.88,
  strokeWidth: 1.667,
  d: "M13 20h14.142m-7.07-7.071V27.07"
})));
export default SvgAdd;